export function excludeArray<T>(key: keyof T, array1: T[], array2: T[]): T[] {
  const keysValueInArray2 = new Set(array2.map(item => item?.[key]));
  return array1.filter(item => !keysValueInArray2.has(item?.[key]));
}
